import utils from '@/utils/common';

export default {
  namespaced: true,
  state: () => ({
    user: null,
    routeAfterSuccessfulLogin: null,
  }),
  getters: {
    isAdmin: state => state.user?.roles?.includes('ROLE_ADMIN'),
    isObserver: state => state.user?.roles?.includes('ROLE_OBSERVER'),
    userMaxProjects: (state) => state.user?.tariff.maxProjects,
    userProjectCount: (state) => state.user?.projectCount,
    userMaxStorage: (state) => utils.formatStorageSize(state.user?.tariff.maxStorage),
    userStorageCount: (state) => utils.formatStorageSize(state.user?.storageCount),
    companyDepartments(state) {
      const getDepartmentsOfCompany = company => !company ? [] : company.departments.map(d => ({ ...d, company: company.name }));

      const companies = state.user?.companies ?? [];
      const employments = state.user?.employments ?? [];

      const departmentsByOwner = companies.reduce((acc, val) => {
        return [...acc, ...getDepartmentsOfCompany(val)];
      }, []);

      const departmentsByDeputy = employments.reduce((acc, val) => {
        const company = val.deputyships?.[0];
        return [...acc, ...getDepartmentsOfCompany(company)];
      }, []);


      const departmentsByMember = employments
        .map(
          e => (e.memberships ?? [])
            .filter(m => m.role === 'head' || m.role === 'manager')
            .map(m => ({ ...m.department, company: m.department.company.name }))
        )
        .reduce((acc, val) => [...acc, ...val], []);

      const allDepartments = [
        ...departmentsByOwner,
        ...departmentsByDeputy,
        ...departmentsByMember,
      ];

      return [...new Map(allDepartments.map(d => [d['@id'], d])).values()];
    },
  },
  mutations: {
    setUser(state, payload) {
      state.user = payload;
    },
    setRouteAfterSuccessfulLogin(state, payload) {
      state.routeAfterSuccessfulLogin = payload;
    },
  },
  actions: { },
};
